import { FaroLighthouseMark } from "../../ui/FaroLighthouseMark";

export function ScanBrand(props: { href: string }) {
  return (
    <a
      class="signal-brand-wrap"
      href={props.href}
      aria-label="Faro Signal workspace home"
    >
      <FaroLighthouseMark class="signal-brand-mark" size={32} />
      <span class="signal-brand-word">Faro.</span>
      <span class="signal-brand-divider" aria-hidden="true" />
      <span class="signal-brand-product">Signal</span>
    </a>
  );
}
